<template>
  <div class="px-2">
    <panel-container :panel-icon="'people'" :panel-title="'All Clients'">
      <template v-slot:panel-content>
        <template v-if="agentData">
          <updated-list-component
            :table-headers="clientsTableHeader"
            :table-data="generateClientList(clientList)"
            class="custom-table-class"
            wrapper-class="pt-5"
            @clicked="onClientNameClicked($event)"
            @send-message-clicked="onSendMessageClicked($event)"
            @resend-invite-clicked="onSendInviteClicked($event)"
          />
        </template>
        <template v-else>
          <v-progress-linear
            height="5"
            :color="$btnHwayzBlue"
            :indeterminate="true"
          />Loading Associated Clients...
        </template>
      </template>
    </panel-container>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState, mapMutations } from 'vuex'
import {
  dateOfLastInvite,
  onSendInviteClicked
} from '../../services/invite-service'
import PanelContainer from '../../components/uiUtils/PanelContainer.vue'
import UpdatedListComponent from '../../components/uiUtils/UpdatedListComponent.vue'

import colors from '../../scss/_colors.scss'
import { sortNames } from '../../utils/generalUtils'

export default {
  components: { PanelContainer, UpdatedListComponent },
  data() {
    return {
      clientsTableHeader: [
        { text: 'Client', value: 'clientName', sortable: false },
        { text: 'Last Active', value: 'lastActive', sortable: false },
        { text: 'Send message', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false }
        // { text: 'Offers Made', value: 'offersMade', sortable: false }
      ],
      colors
    }
  },

  computed: {
    /**
     * Mapping getter to get active agent's data
     */
    ...mapState('agent', ['agentData']),

    clientList() {
      if (this.agentData) {
        return sortNames(this.agentData.clients)
      }
      return []
    }
  },

  methods: {
    /**
     * Mapping agent auth login functionality with the component
     */
    ...mapActions('agent', ['getAgentProfile', 'setSearchedClient']),
    ...mapMutations('agent', {
      setDialogUser: 'SET_DIALOG_USER',
      setAgentData: 'SET_AGENT_DATA'
    }),

    generateClientList(tableDataArray) {
      let responseData = []
      tableDataArray.map((item, index) => {
        const lastActivity = item.lastActivity
          ? moment(item.lastActivity).format('MM-DD-YY')
          : !this.getDateOfLastInvite(item)
            ? 'RESEND INVITE'
            : 'SENT'
        let rowObject = {}
        rowObject[0] = {
          type: 'avatar',
          text: item.name,
          class: 'textLeft text-capitalize',
          data: item
        }
        if (lastActivity === 'RESEND INVITE') {
          rowObject[1] = {
            type: 'clickableText',
            text: lastActivity,
            color: colors.hwayzBrandGold,
            data: {
              type: 'resendInviteClick',
              value: item,
              action: 'resend-invite-clicked'
            }
          }
        } else {
          rowObject[1] = {
            type: 'text',
            text: lastActivity,
            class: 'blue-color'
          }
        }
        rowObject[2] = {
          type: 'icon',
          color: colors.hwayzBlack,
          text: 'chat',
          data: {
            type: 'sendMessageClick',
            value: item,
            action: 'send-message-clicked'
          }
        }
        rowObject[3] = {
          text: item.phone.replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1)-$2-$3')
        }
        // rowObject[4] = { text: '0' }
        responseData.push(rowObject)
      })
      return responseData
    },

    onClientNameClicked(data) {
      this.setSearchedClient(data)
      this.$router.push({ name: 'client-detail' })
    },

    onSendMessageClicked(data) {
      this.setSearchedClient(data)
      this.setDialogUser(data)
      this.$router.push({ name: 'communication' })
    },
    async onSendInviteClicked(client) {
      const updatedProfile = await onSendInviteClicked(client, this.agentData)
      this.setAgentData(updatedProfile)
    },
    getDateOfLastInvite(item) {
      return dateOfLastInvite(item)
    }
  }
}
</script>

<style lang="sass">
.custom-table-class table.v-table thead tr
  th
    font-weight: 500 !important
    color: $hwayzBlack !important
    text-align: center!important
    &:first-child
      text-align: left !important
      padding-left: 32px !important
.blue-color
  color: $hwayzBrandBlue
</style>
